import { Box, BoxProps } from "@dropbox/dig-foundations";
import {
  getBackgroundSvg,
  getFillColors,
  getProfileBackgroundForEmail,
} from "./utils";

import type { UserInfo } from "@mirage/mosaics/UserProfilePage/types";
import type { ProfileBackgroundColor, ProfileBackgroundTheme } from "./types";

export const UserProfileCustomizedBackgroundImage = ({
  user,
  borderRadius = "Large",
  height = "128px",
  width = "100%",
}: {
  user: UserInfo;
  borderRadius?: BoxProps<"div">["borderRadius"];
  height?: string;
  width?: string;
}) => {
  const { backgroundColor, backgroundTheme } = getProfileBackgroundForEmail(
    user.email,
  );
  const colorSetting = user.user_profile_settings.profile_background_color;
  const themeSetting = user.user_profile_settings.profile_background_theme;
  return (
    <UserProfileBackgroundImage
      color={
        colorSetting
          ? (colorSetting as ProfileBackgroundColor)
          : backgroundColor
      }
      theme={
        themeSetting
          ? (themeSetting as ProfileBackgroundTheme)
          : backgroundTheme
      }
      borderRadius={borderRadius}
      height={height}
      width={width}
    />
  );
};

export const UserProfileBackgroundImage = ({
  color,
  theme,
  borderRadius = "Large",
  height = "128px",
  width = "100%",
}: {
  color: ProfileBackgroundColor;
  theme: ProfileBackgroundTheme;
  borderRadius?: BoxProps<"div">["borderRadius"];
  height?: string;
  width?: string;
}) => {
  const { backgroundFillColor } = getFillColors(color);
  const backgroundSvg = getBackgroundSvg(theme, color, height, width);
  const svgDataUri = `data:image/svg+xml;utf8,${encodeURIComponent(backgroundSvg)}`;
  return (
    <Box
      borderRadius={borderRadius}
      style={{
        height,
        width,
        backgroundColor: backgroundFillColor,
        backgroundImage: `url("${svgDataUri}")`,
        backgroundRepeat: "repeat",
        flexShrink: 0,
      }}
    />
  );
};
